import {Component, Input} from '@angular/core';
import {LocalStorageService} from '../../services/local-storage.service';
import {MatSnackBar} from '@angular/material';
import {SalePointsService} from '../../services/sale-points.service';

@Component({
  selector: 'app-basic-info',
  styleUrls: ['./basic-info.component.scss'],
  templateUrl: './basic-info.component.html'
})
export class BasicInfoComponent {
  @Input() mainDataSections: any[];

  constructor(private localStorageService: LocalStorageService,
              private matSnackBar: MatSnackBar,
              private salePointsService: SalePointsService) {
  }

  async updateKey1() {
    const events = this.localStorageService.getItem('events');

    const model = {} as UpdateEntities;
    model.id = this.mainDataSections[0].id;
    model.value = this.mainDataSections[0].values[15].value;

    try {
      await this.salePointsService.updateSalePointKey(model);
      await this.localStorageService.clearStorage('events');
      this.toastMessages(`H ενημέρωση κλειδιού ολοκληρώθηκε με επιτυχία`);
    } catch (e) {
      this.toastMessages(`H ενημέρωση απέτυχε. Λόγος ${e.message}`);
    }
  }

  public setFieldColor(field: any): string {
    return field.color ? field.color : '';
  }

  toastMessages(message) {
    this.matSnackBar.open(message, null, {
      duration: 3000
    });
  }
}
